var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.998 19.546a4.126 4.126 0 00.273 1.262.69.69 0 00.683.415.716.716 0 00.693-.429 3.523 3.523 0 00.274-1.23l.391-4.493a11.932 11.932 0 00.064-1.222 3.67 3.67 0 00-.264-1.563 1.05 1.05 0 00-1.048-.542 1.362 1.362 0 00-1.044.424 1.66 1.66 0 00-.396 1.18q0 .556.082 1.832zm1.012 5.997a1.396 1.396 0 00.956-.365 1.273 1.273 0 00.41-1.002 1.295 1.295 0 00-.406-.962 1.35 1.35 0 00-.98-.396 1.354 1.354 0 00-1.367 1.358 1.262 1.262 0 00.415 1.007 1.434 1.434 0 00.971.36z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9 28.65L16.835 2.515a.933.933 0 00-1.67 0L2.1 28.649A.933.933 0 002.934 30h26.132a.933.933 0 00.834-1.35zM3 29L16 3l13 26z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--exclamation-triangle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'ExclamationTriangleIcon';
export default Icon;